import React, { useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";

export default function ChangePassword() {
  const { t } = useLang();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [nw2, setNw2] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr("");
    if (nw.length < 8) { setErr("New password must be at least 8 characters"); return; }
    if (nw !== nw2) { setErr("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { currentPassword: cur, newPassword: nw });
      setMsg("Password updated"); setCur(""); setNw(""); setNw2("");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Failed to change password");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-change-password-page">
      <h1 className="font-display text-[#F5F1EB] text-3xl mb-8">{t.admin.changePassword}</h1>
      <form onSubmit={submit} className="max-w-md space-y-4">
        <Field label={t.admin.currentPassword} value={cur} onChange={setCur} testid="cp-current" />
        <Field label={t.admin.newPassword} value={nw} onChange={setNw} testid="cp-new" />
        <Field label={`${t.admin.newPassword} (confirm)`} value={nw2} onChange={setNw2} testid="cp-new2" />
        {err && <p className="text-xs text-[#B8342A]" data-testid="cp-error">{err}</p>}
        {msg && <p className="text-xs text-[#C9A55A]" data-testid="cp-success">{msg}</p>}
        <button type="submit" disabled={busy} className="btn-gold disabled:opacity-50" data-testid="cp-submit">
          {busy ? "…" : t.admin.changePassword}
        </button>
      </form>
    </div>
  );
}

const Label = ({ children }) => <label className="text-[10px] text-[#8A8A8A] tracking-[0.18em] uppercase block mb-1">{children}</label>;
function Field({ label, value, onChange, testid }) {
  return (
    <div>
      <Label>{label}</Label>
      <input type="password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="w-full bg-[#0C0C0C] border border-[#2A2A2A] focus:border-[#C9A55A] text-[#F5F1EB] px-3 h-11 text-sm" />
    </div>
  );
}
